import React from 'react';
import { Button, Grid } from '@mui/material';
import { useAccount } from 'wagmi';
import OZKLogo from '../../../Assets/images/Icons/OZKTokenIcon.png';

export const VaultSummary = ({ vault }) => {
  const { isConnected } = useAccount();

  return (
    <Grid container sx={{ alignItems: 'center' }}>
      <Grid
        item
        lg={2}
        md={2}
        sm={4}
        xs={4}
        className="text-white font-poppins text-base font-normal leading-6"
      >
        {vault.epoch}
      </Grid>
      <Grid
        item
        lg={2}
        md={2}
        sm={4}
        xs={4}
        display="flex"
        className="text-white font-poppins text-base font-normal leading-6"
      >
        {isConnected ? `${vault.ozkEarned} OZK` : 'Connect Wallet'}
        {isConnected && (
          <img
            src={OZKLogo}
            alt={'OZK LOGO'}
            width={'18px'}
            height={'18px'}
            className="ml-1 my-1 object-contain"
          />
        )}
      </Grid>
      <Grid
        item
        lg={2}
        md={2}
        display="flex"
        className="text-white font-poppins text-base font-normal leading-6"
        sx={{ display: { xs: 'none', md: 'flex' } }}
      >
        {isConnected ? `${vault.ozkStaked} OZK` : 'Connect Wallet'}
        {isConnected && (
          <img
            src={OZKLogo}
            alt={'OZK LOGO'}
            width={'18px'}
            height={'18px'}
            className="ml-1 my-1 object-contain"
          />
        )}
      </Grid>
      <Grid
        item
        lg={1.5}
        md={1.5}
        className="text-white font-poppins text-base font-bold leading-6"
        sx={{ display: { xs: 'none', md: 'block' } }}
      >{`${vault.apr}%`}</Grid>
      <Grid item lg={2} md={2} sm={4} xs={4}>
        {vault.endsIn}
      </Grid>
      <Grid item lg={2.5} md={2.5}>
        <Button
          sx={{
            display: { xs: 'none', md: 'flex' },
            height: '39px',
            width: 'auto',
            background:
              'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
            border: '1px solid  #FC9D4B',
            borderColor: '#FC9D4B',
            borderRadius: '25px',
            color: '#FFFFFF',
            fontWeight: 'semibold',
            fontFamily: 'PoppinsRegular',
            fontSize: '18px',
            padding: '7px 15px',
            '&:hover': {
              background:
                'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
              boxShadow: '0px 0px 13px 1px #FC9D4B',
            },
            textTransform: 'none',
          }}
        >
          {vault.action}
        </Button>
      </Grid>
    </Grid>
  );
};
